// extracted by mini-css-extract-plugin
export default {"pagination":"paginateCard_pagination__YGNpU","active":"paginateCard_active__xXaKS"};